import { useState, useMemo, useEffect } from "react";
import { CssBaseline } from "@mui/material";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import { PaletteMode } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";
import Layout from "./components/Layout";
import { getDesignTokens, ColorModeContext } from "./theme";
import ProductConfigurator from "./pages/admin/product.page";
import PriceConfigurator from "./pages/admin/price.page";
import PromptConfigurator from "./pages/admin/prompt.page";
import Dashboard from "./pages/admin/dashboard.page";
import Subscribelist from "./pages/admin/subscribe.page";
import ContentGenerator from "./pages/admin/blogcreate.page";
import ContentEditor from "./pages/admin/blogedit.page";
import GeniePage from "./pages/genie.page";
import LandingPage from "./pages/landing.page";
import AnycodeLandingPage from "./pages/Anycode_landing";
import SignupPage from "./pages/auth/signup.page";
import TermsPage from "./pages/auth/terms.page";
import SigninPage from "./pages/auth/signin.page";
import ForgotPage from "./pages/auth/forgot.page";
import VerifyPage from "./pages/auth/verify.page";
import RequireUser from "./components/requireUser";
import UnauthorizePage from "./pages/unauthorized.page";
import PricingPage from "./pages/pricing.page";
import PrivacyPage from "./pages/auth/privacy.page";
import DataDeletionPage from "./pages/auth/DataDeletionPage";
import FeedbackPage from "./pages/feedback.page";
import PaymentPage from "./pages/payment/payment.page";
import SuccessPage from "./pages/payment/success.page";
import CardUpdatedPage from "./pages/payment/success_card_update.page";
import ADiveBlogs from "./blogs/A_Dive_into_Decentralization.blogs";
import ADiveBlogs1 from "./blogs/A_Dive_into_Decentralization.blogs1";
import ADiveintoBlogs from "./blogs/A_Dive_into.blogs";
import ADiveintoBlogs1 from "./blogs/A_Dive_into.blogs1";
import TheAIAdvantage from "./blogs/The_AI_Advantage.blogs";
import BeyondSecurity from "./blogs/Beyond_Security.blogs";
import UnveilingCodeGenie from "./blogs/Unveiling_Code_Genie.blogs";
import CostEffectiveAuditing from "./blogs/Cost_Effective_Auditing.blogs";
import ANoviceInBlockchain from "./blogs/A_Novice_In_Blockchain.blogs";
import OneClickMultipleSolutions from "./blogs/One_Click_Multiple_Solutions.blogs";
import RealtimeRectifications from "./blogs/Real_time_Rectifications.blogs";
import UpgradingtheUpgradable from "./blogs/Upgrading_the_Upgradable.blogs";
import BreakingDowntheTechnical from "./blogs/Breaking_Down_the_Technical.blogs";
import TheEthicalEdge from "./blogs/The_Ethical_Edge.blogs";
import TheEvolutionofAudits from "./blogs/The_Evolution_of_Audits.blogs";
import BlogIndexPage from "./pages/BlogIndexPage";
import { Sitemap } from "./Sitemap";
import Aboutus from "./pages/auth/Aboutus.page";
import Contactus from "./pages/auth/contactus.page"
import { useParams } from "react-router-dom";
import './assets/css/bootstrap.min.css';
import './assets/css/mic_icon.css';
import ContactusPage from "./pages/contactus.page";
import Usersetting from "./pages/Usersetting";
import NotFoundPage from './pages/NotFound';
import Dashboard_tm from './pages/traffic_monster/dashboard_tm';
import Generated_Blogs from "./pages/traffic_monster/generated_blogs";
import Blogs_List from "./pages/traffic_monster/blogs_list";
import TrafficMonsterlandingnew from "pages/traffic_monster/traffic_monster_landing_new";
import Campaign_List from "./pages/traffic_monster/campaigns/campaign_list";
import New_Campaign from "./pages/traffic_monster/campaigns/new_campaign";
import New_Podcast from "./pages/traffic_monster/campaigns/new_podcast";
import New_Course_Intro from "./pages/traffic_monster/campaigns/new_course_intro";
import New_Course from "./pages/traffic_monster/campaigns/new_course";
import New_Course_1 from "./pages/traffic_monster/campaigns/new_course_1";
import New_Course_2 from "./pages/traffic_monster/campaigns/new_course_2";
import New_Course_3 from "./pages/traffic_monster/campaigns/new_course_3";
import New_Course_4 from "./pages/traffic_monster/campaigns/new_course_4";
import OnboardingPage from "./pages/traffic_monster/campaigns/onboardingPage";
import ActivationSuccessPage from "./pages/traffic_monster/activation_success_page";
// import { usePlanDetailsMutation } from "./redux/api/productApi";
import VerifySite from "./pages/verifySite.page";
import ReferrealProcess from "pages/payment/referreal_process";
import TrafficMonsLandingNew from "pages/traffic_monster/landing_page_tm_new";
import PodcastMonsterLanding from "pages/podcast_monster/podcast_monster_landing";
import { getCookie, removeCookie } from "utils/storageUtils";
import OceshaLanding from "pages/ocesha_landing/ocesha_landing_page";
import Ocesha_new_design from "pages/ocesha_landing/ocesha_new_design";
import EditBlog from "pages/ocesha_landing/edit_blog";
import EditClip from "pages/ocesha_landing/edit_clip";
import OceshaLandingNew from "pages/ocesha_landing/ocesha_landing_page_new";
import OceshaPodcastLandingNew from "pages/ocesha_landing/ocesha_podcast_landing_new";
import OceshaAgencyLandingNew from "pages/ocesha_landing/ocesha_agency_landing_new";
import OceshaSmallBusiLandingNew from "pages/ocesha_landing/ocesha_small_busi_landing_new";
import DashboardNew from "pages/admin/dashboard_new.page";
import OceshaAboutUs from "pages/ocesha_landing/ocesha_about_us";
import Callback from "pages/ocesha_landing/callback";
import New_Course_2_1 from "pages/traffic_monster/campaigns/new_course_2_1";
import ListingCourses from "pages/traffic_monster/campaigns/listing-courses";
import CourseDetailScreen from "pages/traffic_monster/campaigns/view-course";
import CourseEditorScreen from "pages/traffic_monster/campaigns/edit_course";
import InstructorProfilePage from "pages/traffic_monster/campaigns/instructor_profile_page";
import IndividualEpisodePage from "./pages/traffic_monster/campaigns/individual_episode_page";
import IndividualCoursesPage from "pages/traffic_monster/campaigns/individual_courses_page";
import CreatorDirectory from "pages/traffic_monster/campaigns/creator_directory";
import CoursesDirectory from "pages/traffic_monster/campaigns/courses_directory";
import Aiacceptable from "pages/auth/Aiacceptable";
import Creatormonetization from "pages/auth/Creatormonetization";
import Paymentprocessing from "pages/auth/paymentprocessing";
import CourseSuccess from "pages/payment/course_success.page";
import AuthorityEngine from "pages/traffic_monster/campaigns/authorityEngine";
import SocialPost from "pages/traffic_monster/campaigns/socialPost";
import Marketing from "pages/traffic_monster/campaigns/marketing";
import DigitalTwinScreen from "pages/traffic_monster/campaigns/Mydigitaltwinscreen";
import Myprofilepage from "pages/traffic_monster/campaigns/My_profile_page";
import JobStatusToast from "components/JobStatusToast";
import LinkedinCallback from "pages/auth/linkedin_calback";
import CustomerAcquisitionDashboard from "pages/traffic_monster/campaigns/CustomerAcquisitionDashboard";
import CustomerNewAcquisition from "pages/traffic_monster/campaigns/CustomerNewAcquisition";
import MessagesAndFollowers from "pages/traffic_monster/campaigns/message";
import PublishScheduleClip from "pages/ocesha_landing/PublishScheduleClip";
import OnboardingCompletePage from "pages/traffic_monster/campaigns/OnboardingCompletePage";
import AnalyticsDashboard from "pages/traffic_monster/campaigns/analytics";
import Course_Suggestions from "pages/traffic_monster/campaigns/course_suggestions";
import visitcourse from "pages/traffic_monster/campaigns/visitcourse";
import Visitcourse from "pages/traffic_monster/campaigns/visitcourse";
import ConnectSuccess from "./pages/payment/connect_success.page";
import CourseThankYou from "./pages/payment/CourseThankYou";
import GBA_Registration from "pages/auth/GBA_Registration";
import GBARegistrationSuccess from "pages/auth/GBARegistrationSuccess";
import { CourseGenerationProvider } from "./contexts/CourseGenerationContext";
import CourseGenerationBanner from "./components/CourseGenerationBanner";
import ConnectShopline from "pages/traffic_monster/campaigns/ConnectShopline";
import VerifyCertificatePage from "./pages/verify_certificate.page";


function App() {
  const [mode, setMode] = useState<PaletteMode>("dark");
  const userRole = localStorage.getItem('userRole');
  const loggedIn = localStorage.getItem('logged_in');
  const user_email = localStorage.getItem('user_email');
  const location = useLocation();
  const navigate = useNavigate();

  const currentUrl = window.location.href;
  const pathName = location.pathname;
  const domainName = new URL(currentUrl).hostname;



  /* const [planDetails, setPlanDetails] = useState<any>();

  const [getuserPlanDetails] = usePlanDetailsMutation(); */

  /* const colorMode = useMemo(
    () => ({

      toggleColorMode: () => {
        {
          userRole === 'admin' ?
            setMode((prevMode: PaletteMode) =>
              prevMode === "light" ? "light" : "light"
            ) : setMode((prevMode: PaletteMode) =>
              prevMode === "light" ? "dark" : "dark"
            )
        }
      },
    }),
    []
  ); */

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        const newMode = userRole === 'admin'
          ? 'light'
          : (mode === 'light' ? 'dark' : 'light');

        setMode(newMode);
        localStorage.setItem('theme', newMode);
      },
    }),
    [mode, userRole]
  );

  useEffect(() => {
    window.isMutedGlobal = false;
  }, []);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as PaletteMode | null;
    if (savedTheme) {
      setMode(savedTheme);
    } else {
      setMode(userRole === 'admin' ? 'light' : 'dark');
    }
  }, [userRole]);

  useEffect(() => {
    const match = location.pathname.match(/^\/partner\/([^/]+)$/);

    if (match) {
      const partnerName = decodeURIComponent(match[1]);

      localStorage.setItem("partner_name", partnerName);

      // navigate("/signup", {
      //   replace: true,
      // });
      window.location.replace("/signup");
    }
  }, [location.pathname, navigate]);



  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  const handleUserActivity = () => {
    setLastActiveTime(Date.now());
  };

  const [lastActiveTime, setLastActiveTime] = useState<number>(Date.now());
  const [isRedirecting, setIsRedirecting] = useState(true);

  //redirect to home page if not logged in
  useEffect(() => {
    // Redirect only if not on '/' and the variable is missing

    if (!user_email && getCookie('user_email') && loggedIn == "true") {
      localStorage.setItem('user_email', getCookie('user_email') || "");
    }

    else if (loggedIn != "true" && !user_email && pathName !== '/' && pathName !== '/pricing' && !pathName.includes('sitemap') &&
      pathName !== '/contactus' && pathName !== '/signin' && pathName !== '/signup' && !pathName.includes('PreviewBlogs1') &&
      pathName !== '/terms' && pathName !== '/privacy' && pathName !== '/forgot' && pathName !== '/referral-process' &&
      !pathName.includes('blogs') && pathName !== '/podcast' && !pathName.includes('/blog/') && !pathName.includes('/profile') &&
      !pathName.includes('course') && pathName !== '/connect-success' && pathName !== '/connect_success' &&
      pathName !== '/agency' && pathName !== '/small-business' && pathName !== '/aboutus' && 
      !pathName.startsWith("/codegenie/creator-directory") && pathName !== '/data-deletion' &&
        !pathName.startsWith("/codegenie/courses-directory") &&
        !pathName.startsWith('/verify-certificate') && 
        !pathName.startsWith('/partner/')) {

    navigate('/', { replace: true });
  }
}, [navigate, pathName]);

/* && pathName !== '/codegenie/creator-directory' && pathName !== '/codegenie/creator-directory/:partnerName' && pathName !== '/codegenie/courses-directory/:partnerName' && pathName !== '/codegenie/courses-directory' */

useEffect(() => {
  // Redirection logic
  if (
    !currentUrl.includes('podcastmonster') &&
    !currentUrl.includes('localhost') &&
    !currentUrl.includes('podcastmonster.ai') &&
    !currentUrl.includes('ocesha') &&
    !pathName.startsWith('/blogs') &&
    !pathName.startsWith('/blog') &&
    !pathName.startsWith('/codegenie') &&
    !pathName.startsWith('/admin') &&
    !pathName.startsWith('/partner')
  ) {
    window.location.href = `https://${domainName}/blogs`;
  } else {
    setIsRedirecting(false);
  }
}, [currentUrl, domainName, pathName]);

/* useEffect(() => {
  if (isRedirecting) return;
  const timeoutDuration = 1200000; // 20 minutes in milliseconds


  pathName.startsWith('/blog')
  window.addEventListener("mousemove", handleUserActivity);
  window.addEventListener("keydown", handleUserActivity);

  const checkTimeout = () => {
    const currentTime = Date.now();

    if (pathName.startsWith('/success') || pathName.startsWith('/codegenie/new-campaign')) {
      setLastActiveTime(currentTime);
    }
    const elapsedTime = currentTime - lastActiveTime;



    if (elapsedTime >= timeoutDuration && !pathName.startsWith('/success') && !pathName.startsWith('/codegenie/new-campaign')) {
      localStorage.removeItem("msg");
      localStorage.removeItem("complexity");
      localStorage.removeItem("module");
      localStorage.removeItem("subscription_level");
      localStorage.removeItem("free_plan");
      localStorage.removeItem("localStorage_msg");
      localStorage.removeItem("allSet");
      localStorage.removeItem("Blogs Generated");
      localStorage.removeItem("remaining_wish_count");
      localStorage.removeItem("userRole");
      localStorage.removeItem("payment");
      localStorage.removeItem("user_email");
      localStorage.removeItem("logged_in");
      localStorage.removeItem("prevImg");
      localStorage.removeItem("fromUpgrade");
      localStorage.removeItem("blogsCount");
      localStorage.removeItem("Generating Count");
      localStorage.removeItem("finalData");
      localStorage.removeItem("user_pass");
      localStorage.removeItem("fromNewcampaign");
      localStorage.removeItem("campaignid");
      localStorage.removeItem("returningtocampaign");
      localStorage.removeItem('sourceurl');
      localStorage.removeItem('campaignName');
      localStorage.removeItem('paymentOption');
      localStorage.removeItem('autoPublish');
      localStorage.removeItem('limitPublish');
      localStorage.removeItem('campId');
      localStorage.removeItem('campaignid');
      localStorage.removeItem('returningtocampaign');
      localStorage.removeItem('sourceurl');
      localStorage.removeItem('campaignName');
      localStorage.removeItem('paymentOption');
      localStorage.removeItem('autoPublish');
      localStorage.removeItem('limitPublish');
      localStorage.removeItem('smUrlpublish');
      localStorage.removeItem('addTags');
      localStorage.removeItem('captureLeads');
      localStorage.removeItem('newsLetter');
      localStorage.removeItem('twitterBtn');
      localStorage.removeItem('fbBtn');
      localStorage.removeItem('pintrestBtn');
      localStorage.removeItem('linkedinBtn');
      localStorage.removeItem('video');
      localStorage.removeItem('twitterurl');
      localStorage.removeItem('fburl');
      localStorage.removeItem('pintresturl');
      localStorage.removeItem('linkedinurl');
      localStorage.removeItem('owndomain');
      localStorage.removeItem('ChangepayMode');
      localStorage.removeItem('IdChangingMode');
      localStorage.removeItem('user_name');
      localStorage.removeItem('refreshCount');
      localStorage.removeItem('publishingCampId');
      localStorage.removeItem('Authorurl');
      localStorage.removeItem('Authorname');
      localStorage.removeItem('authorDefaultCheck');
      localStorage.removeItem('appsumo_coupon_code');
      localStorage.removeItem('podcastUrl');
      localStorage.removeItem('AlertMessage');
      localStorage.removeItem('CreatingfromLanding');
      localStorage.removeItem('UrlfromLanding');
      localStorage.removeItem('signedup');
      localStorage.removeItem('uploadedvideo');
      localStorage.removeItem('uploadedVideoName');
      localStorage.removeItem('uploadStatus');

      navigate("/signin", { replace: true });
    } else {
      const remainingTime = timeoutDuration - elapsedTime;
      setTimeout(checkTimeout, remainingTime);
    }
  };

  window.addEventListener("mousemove", handleUserActivity);
  window.addEventListener("keydown", handleUserActivity);

  const timeoutId = setTimeout(checkTimeout, timeoutDuration);

  return () => {
    window.removeEventListener("mousemove", handleUserActivity);
    window.removeEventListener("keydown", handleUserActivity);

    clearTimeout(timeoutId);
  };
}, [lastActiveTime, navigate, isRedirecting]); */

const clearCookies = () => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [name] = cookie.split("=");
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
  }
};

useEffect(() => {
  if (isRedirecting) return;
  const timeoutDuration = 1200000; // 20 minutes in milliseconds


  pathName.startsWith('/blog')
  window.addEventListener("mousemove", handleUserActivity);
  window.addEventListener("keydown", handleUserActivity);

  const checkTimeout = () => {
    const currentTime = Date.now();

    if (pathName.startsWith('/success') || pathName.startsWith('/codegenie/new-campaign')) {
      setLastActiveTime(currentTime);
    }
    const elapsedTime = currentTime - lastActiveTime;


    var a = 1
    var b = 4
    if (elapsedTime >= timeoutDuration && a == b && !pathName.startsWith('/success') && !pathName.startsWith('/codegenie/new-campaign')) {
      clearCookies();
      clearLocalStorage();
      navigate("/signin", { replace: true });
    } else {
      const remainingTime = timeoutDuration - elapsedTime;
      setTimeout(checkTimeout, remainingTime);
    }
  };

  const clearLocalStorage = () => {
    localStorage.removeItem("msg");
    localStorage.removeItem("complexity");
    localStorage.removeItem("module");
    localStorage.removeItem("subscription_level");
    localStorage.removeItem("free_plan");
    localStorage.removeItem("localStorage_msg");
    localStorage.removeItem("allSet");
    localStorage.removeItem("Blogs Generated");
    localStorage.removeItem("remaining_wish_count");
    localStorage.removeItem("userRole");
    localStorage.removeItem("payment");
    localStorage.removeItem("user_email");
    localStorage.removeItem("logged_in");
    localStorage.removeItem("prevImg");
    localStorage.removeItem("fromUpgrade");
    localStorage.removeItem("blogsCount");
    localStorage.removeItem("Generating Count");
    localStorage.removeItem("finalData");
    localStorage.removeItem("user_pass");
    localStorage.removeItem("fromNewcampaign");
    localStorage.removeItem("campaignid");
    localStorage.removeItem("returningtocampaign");
    localStorage.removeItem('sourceurl');
    localStorage.removeItem('campaignName');
    localStorage.removeItem('paymentOption');
    localStorage.removeItem('autoPublish');
    localStorage.removeItem('limitPublish');
    localStorage.removeItem('campId');
    localStorage.removeItem('campaignid');
    localStorage.removeItem('returningtocampaign');
    localStorage.removeItem('sourceurl');
    localStorage.removeItem('campaignName');
    localStorage.removeItem('paymentOption');
    localStorage.removeItem('autoPublish');
    localStorage.removeItem('limitPublish');
    localStorage.removeItem('smUrlpublish');
    localStorage.removeItem('addTags');
    localStorage.removeItem('captureLeads');
    localStorage.removeItem('newsLetter');
    localStorage.removeItem('twitterBtn');
    localStorage.removeItem('fbBtn');
    localStorage.removeItem('pintrestBtn');
    localStorage.removeItem('linkedinBtn');
    localStorage.removeItem('video');
    localStorage.removeItem('twitterurl');
    localStorage.removeItem('fburl');
    localStorage.removeItem('pintresturl');
    localStorage.removeItem('linkedinurl');
    localStorage.removeItem('owndomain');
    localStorage.removeItem('ChangepayMode');
    localStorage.removeItem('IdChangingMode');
    localStorage.removeItem('user_name');
    localStorage.removeItem('refreshCount');
    localStorage.removeItem('publishingCampId');
    localStorage.removeItem('Authorurl');
    localStorage.removeItem('Authorname');
    localStorage.removeItem('authorDefaultCheck');
    localStorage.removeItem('appsumo_coupon_code');
    localStorage.removeItem('podcastUrl');
    localStorage.removeItem('AlertMessage');
    localStorage.removeItem('CreatingfromLanding');
    localStorage.removeItem('UrlfromLanding');
    localStorage.removeItem('signedup');
    localStorage.removeItem('uploadedvideo');
    localStorage.removeItem('uploadedVideoName');
    localStorage.removeItem('uploadStatus');
  };

  window.addEventListener("mousemove", handleUserActivity);
  window.addEventListener("keydown", handleUserActivity);

  const timeoutId = setTimeout(checkTimeout, timeoutDuration);


  // Clear localStorage when the tab or window is closed
  /* const handleUnload = () => {
    clearLocalStorage();
  }; */
  // window.addEventListener("beforeunload", handleUnload);


  return () => {
    window.removeEventListener("mousemove", handleUserActivity);
    window.removeEventListener("keydown", handleUserActivity);

    clearTimeout(timeoutId);
  };
}, [lastActiveTime, navigate, isRedirecting]);


// Global subscription guard
useEffect(() => {
  if (isRedirecting) return;
  if (!loggedIn || loggedIn !== "true" || !user_email) return;

  const userRole = localStorage.getItem("userRole");
  const subscriptionLevel = localStorage.getItem("subscription_level");
  const expired = localStorage.getItem("expired");

  const hasValidSubscription = (level: string | null) => {
    return level !== undefined && level !== null && level !== "";
  };

  const hasValidExpiry = expired === "false"; //returns true if not expired

  // Pages that don't require subscription check
  const exemptPaths = [
    "/pricing",
    "/signin",
    "/signup",
    "/forgot",
    "/terms",
    "/privacy",
    "/success",
    "/course-success",
    "/connect-success",
    "/connect_success",
    "/referral-process",
    "/card_updated",
    "/checkout",
    "/unauthorized",
    "/callback",
    "/data-deletion",
    "/feedback",
    "/auth/linkedin/callback",
    "/profile/",      // covers /profile/:mentorId
    "/blog/",         // covers /blog/:profile_id/:blog_url
    "/course/",       // covers /course/:profile_id/:course_url
    "/PreviewBlogs/",
    "/PreviewBlogs1",
    "/codegenie/individual-course",
    "/verify-certificate",
  ];

  const isExempt = exemptPaths.some((p) => pathName.startsWith(p));

  if (isExempt) return;

  if (userRole === "user" && !hasValidSubscription(subscriptionLevel)) {
    navigate("/pricing", { replace: true });
  }
  else if (userRole === "user" && !hasValidExpiry) {
    localStorage.setItem("fromUpgrade", "true");
    localStorage.setItem('activeItem', 'upgrade');
    navigate("/codegenie/generated-blogs");
  }
}, [pathName, loggedIn, user_email, isRedirecting]);


const userEmail = localStorage.getItem('user_email') || '';

if (isRedirecting) {
  return null; // or a loading spinner if desired
}

return (

  <ColorModeContext.Provider value={colorMode}>
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <CssBaseline />
      {/* <JobStatusToast /> */}
      <CourseGenerationProvider>
        <CourseGenerationBanner />
        <Routes>
          {/* <Route path="/landingold" element={<LandingPage />} />
            <Route path="/landingnew" element={<TrafficMonsLandingNew />} />
            <Route path="/oceshalandingnew" element={<OceshaLandingNew />} /> */}
          {/* <Route path="/" element={<TrafficMonsterlandingnew />} /> */}
          {/* <Route path="/" element={<OceshaLanding />} /> */}
          <Route path="/" element={<OceshaLandingNew />} />
          <Route path="/podcast" element={<OceshaPodcastLandingNew />} />
          <Route path="/agency" element={<OceshaAgencyLandingNew />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/small-business" element={<OceshaSmallBusiLandingNew />} />
          {/* <Route path="/" element={<PodcastMonsterLanding />} /> */}
          <Route path="/Anycode_landing" element={<AnycodeLandingPage />} />
          <Route path="sitemap" element={<Sitemap />} />
          {/* <Route path="/aboutus" element={<Aboutus />} /> */}
          <Route path="/aboutus" element={<OceshaAboutUs />} />
          <Route path="/aboutuspage" element={<Aboutus />} />
          <Route path="/contactus" element={<ContactusPage />} />
          <Route path="/contactuspage" element={<Contactus />} />
          <Route path="/verifySite" element={<VerifySite />} />

          <Route path="/codegenie/creator-directory" element={<CreatorDirectory />} />
          <Route path="/codegenie/creator-directory/:partnerName" element={<CreatorDirectory />} />

          <Route path="/codegenie/courses-directory" element={<CoursesDirectory />} />
          <Route path="/codegenie/courses-directory/:partnerName" element={<CoursesDirectory />} />

          <Route path="/codegenie/individual-course" element={<IndividualCoursesPage />} />
          <Route path="/course/:profile_id/:course_url" element={<IndividualCoursesPage />} />
          <Route path="/codegenie/analytics" element={<AnalyticsDashboard />} />

          <Route path="/profile/:mentorId" element={<InstructorProfilePage />} />
          <Route path="/blog/:profile_id/:blog_url" element={<ADiveintoBlogs1 />} />

          <Route path="/verify-certificate" element={<VerifyCertificatePage />} />
          <Route path="/verify-certificate/:code" element={<VerifyCertificatePage />} />


          <Route element={<RequireUser allowedRoles={["admin", "user"]} />}>
            <Route path="/" element={<Layout type="user" page="" />}>
              <Route path="codegenie/dashboard" element={<Dashboard_tm />} />
            </Route>
            <Route path="/ocesha/publish-schedule-clip" element={<PublishScheduleClip />} />
          </Route>
          <Route path="/" element={<Layout type="user" page="pricing" />}>
            <Route path="pricing" element={<PricingPage />} />
          </Route>
          <Route element={<RequireUser allowedRoles={["admin"]} />}>
            <Route path="/admin" element={<Layout type="admin" page="" />}>
              {/* <Route path="dashboard" element={<Dashboard />} /> */}
              <Route path="dashboard" element={<DashboardNew />} />
              <Route path="subscribelist" element={<Subscribelist />} />
              <Route path="config">
                <Route path="products" element={<ProductConfigurator />} />
                <Route path="prompts" element={<PromptConfigurator />} />
                <Route path="prices" element={<PriceConfigurator />} />
              </Route>
              <Route path="content">
                <Route path="edit" element={<ContentEditor />} />
              </Route>
            </Route>
          </Route>
          {loggedIn === "true" && user_email != "" ? (
            <>
              {/* <Route path="/codegenie/generated-blogs" element={<Generated_Blogs />} /> */}
              <Route path="/codegenie/generated-blogs" element={<Ocesha_new_design />} />

              {/* <Route path="/ocesha" element={<Ocesha_new_design />} /> */}
              <Route path="/ocesha-edit-blog" element={<EditBlog />} />
              <Route path="/ocesha-edit-clip" element={<EditClip />} />

              <Route path="/auth/linkedin/callback" element={<LinkedinCallback />} />
              <Route path="/codegenie/blogs-list" element={<Blogs_List />} />
              {/* {planDetails?.subscription_level === 'level_3' || planDetails?.subscription_level === 'level_6' ? */}
              {/* <> */}
              {/* <Route path="/codegenie/campaign-list" element={<Campaign_List />} /> */}
              <Route path="/codegenie/new-campaign" element={<New_Campaign />} />
              <Route path="/codegenie/new-podcast" element={<New_Podcast />} />
              <Route path="/codegenie/new-course-intro" element={<New_Course_Intro />} />
              <Route path="/codegenie/new-course" element={<New_Course />} />
              <Route path="/codegenie/new-course-1" element={<New_Course_1 />} />
              <Route path="/codegenie/new-course-2" element={<New_Course_2 />} />
              <Route path="/codegenie/new-course-2-1" element={<New_Course_2_1 />} />
              <Route path="/codegenie/new-course-3" element={<New_Course_3 />} />
              <Route path="/codegenie/new-course-4" element={<New_Course_4 />} />
              <Route path="/codegenie/onboarding_page" element={<OnboardingPage />} />
              <Route path="/codegenie/generated-courses" element={<ListingCourses />} />
              <Route path="/codegenie/authorityEngine" element={<AuthorityEngine />} />
              <Route path="/codegenie/socialPost" element={<SocialPost />} />
              <Route path="/codegenie/marketing" element={<Marketing />} />
              <Route path="/codegenie/edit-course" element={<CourseEditorScreen />} />
              <Route path="/codegenie/instructor-profile" element={<InstructorProfilePage />} />
              <Route path="/codegenie/episode-detail" element={<IndividualEpisodePage />} />
              <Route path="/codegenie/connect-shopline" element={<ConnectShopline />} />




              {/* </> */}
              {/* : */}
              {/* <Route path="/notfound" element={<NotFoundPage />} /> */}
              {/* } */}
              <Route path="/activation-success" element={<ActivationSuccessPage />} />
            </>
          ) : (
            <Route path="/signin" element={<SigninPage />} />
          )}
          <Route path="/partner/:partnerName" element={<></>} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/signin" element={<SigninPage />} />
          <Route path="/verify" element={<VerifyPage page="signin" setPassCallback={() => true} />} />
          <Route path="/forgot" element={<ForgotPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/data-deletion" element={<DataDeletionPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/checkout" element={<PaymentPage />} />
          <Route path="/notfound" element={<NotFoundPage />} />
          <Route path="/codegenie/settings" element={<Usersetting />} />
          <Route path="/" element={<Layout type="user" page="pricing" />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/course-success" element={<CourseSuccess />} />
          <Route path="/codegenie/course-thankyou" element={<CourseThankYou />} />
          <Route path="/connect-success" element={<ConnectSuccess />} />
          <Route path="/connect_success" element={<ConnectSuccess />} />
          <Route path="/referral-process" element={<ReferrealProcess />} />
          <Route path="/card_updated" element={<CardUpdatedPage />} />
          <Route path="/blog/:url.htm" element={<ADiveintoBlogs1 />} />
          <Route path="/blogs1/:url" element={<ADiveBlogs1 />} />

          <Route path="/PreviewBlogs/:blog_id" element={<ADiveintoBlogs />} />
          <Route path="/PreviewBlogs1/:blog_id" element={<ADiveintoBlogs1 />} />
          <Route path="/blogs/The_AI_Advantage" element={<TheAIAdvantage />} />
          <Route path="/blogs/Beyond_Security" element={<BeyondSecurity />} />
          <Route path="/blogs/Unveiling_Code_Genie" element={<UnveilingCodeGenie />} />
          <Route path="/blogs/Cost_Effective_Auditing" element={<CostEffectiveAuditing />} />
          <Route path="/blogs/A_Novice_In_Blockchain" element={<ANoviceInBlockchain />} />
          <Route path="/blogs/One_Click_Multiple_Solutions" element={<OneClickMultipleSolutions />} />
          <Route path="/blogs/Real_time_Rectifications" element={<RealtimeRectifications />} />
          <Route path="/blogs/Upgrading_the_Upgradable" element={<UpgradingtheUpgradable />} />
          <Route path="/blogs/Breaking_Down_the_Technical" element={<BreakingDowntheTechnical />} />
          <Route path="/blogs/The_Ethical_Edge" element={<TheEthicalEdge />} />
          <Route path="/blogs/The_Evolution_of_Audits" element={<TheEvolutionofAudits />} />
          <Route path="/blogs" element={<BlogIndexPage />} />
          <Route path="/codegenie/course-detail" element={<CourseDetailScreen />} />
          <Route path="/course/:courseSlug" element={<CourseDetailScreen />} />
          <Route path="/unauthorized" element={<UnauthorizePage />} />
          <Route path="/paymentprocessing" element={<Paymentprocessing />} />
          <Route path="/creatormonetization" element={<Creatormonetization />} />
          <Route path="/aiacceptable" element={<Aiacceptable />} />
          <Route path="/digitaltwinscreen" element={<DigitalTwinScreen />} />
          <Route path="/profilepage" element={<Myprofilepage />} />
          <Route path="/codegenie/customerAcquisitionDashboard" element={<CustomerAcquisitionDashboard />} />
          <Route path="/codegenie/customerNewAcquisition" element={<CustomerNewAcquisition />} />
          <Route path="/message" element={<MessagesAndFollowers />} />
          <Route path="/codegenie/onboarding-complete" element={<OnboardingCompletePage />} />
          <Route path="/codegenie/Course_Suggestions" element={<Course_Suggestions />} />
          <Route path="/profile/:mentorId" element={<InstructorProfilePage />} />
          <Route path="/codegenie/visitcourse" element={<Visitcourse />} />
          {/* <Route path="/gba-reg" element={<GBA_Registration />} />
            <Route path="/gba-reg-success" element={<GBARegistrationSuccess />} /> */}

          {/* Catch-all: anything that doesn't match an existing route (including
              routes that are conditionally omitted above when logged out, like
              /codegenie/*) falls through here instead of rendering a blank page. */}
          <Route
            path="*"
            element={
              <>
                {console.warn("CATCH-ALL hit for:", location.pathname, location.search)}
                <Navigate to="/signin" state={{ from: location }} replace />
              </>
            }
          />

        </Routes>
      </CourseGenerationProvider>  
    </ThemeProvider>
  </ColorModeContext.Provider>

);
}

export default App;